<template lang="pug">
  v-flex
    v-container
      v-layout
        v-text-field(v-model='search' prepend-icon='fa-search' label='Buscar código' single-line hide-details)
      v-layout.mt-5   
          h2 Libro mayor
          v-spacer
          registro_saldo_inicial
      v-layout.mt-4
          v-flex
              v-data-table.elevation-1( 
                :headers="headers" 
                :items='registro'
                :search='search' 
                :loading='Libro_diario.cargando'
                :footer-props='footerProps'
                :options.sync='options'
                item-key='id'
                :server-items-length='Libro_diario.cantidad_de_registros'
              )
                template( v-slot:item.action="props")
                  span {{props.item.numeracion}}   
</template>
<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import {coleccion_de_periodo_contable, coleccion_partidas_contables} from '@/FirebaseConfig'
export default {
    data: ()=>({
      search: '',
      headers: [
          { text: 'Nº', value: 'numeracion', sortable: false },       
          { text: 'Código', value: 'codigo', sortable: false },       
          { text: 'Debe',  value: 'debe', sortable: false},              
          { text: 'Haber',  value: 'haber', sortable: false},      
          { text: 'Creado por', value: 'creado_por', sortable: false},
          { text: 'Creado el', value: 'creado_el', sortable: false},
          { text: 'Referencia', value: 'referencia', sortable: false},
      ],
      options: {},
      footerProps: {
        'items-per-page-options':    [15, 50, 250]
      },
    }),
    computed:{
      ...mapGetters({
        registro: 'Libro_diario/registro',
      }),
      ...mapState({
        Libro_diario: state=>state.Libro_diario,
        db_activada: state=>state.Customers.db_activada,
      })
    },
    methods:{
      ...mapActions({
        obtener_todo: 'Libro_diario/obtener_todo',
      }),
    },
    components: {
      registro_saldo_inicial: ()=>import('../../contable/componentes/registroSaldoInicial')
    },
    watch: {
      'db_activada'(){
        this.obtener_todo({itemsPerPage: 15, page: 1})         
      },
      options: {
        handler () {
          this.obtener_todo(this.options)
        },
        deep: true,
      },
    },
    created(){
      if(this.db_activada) this.obtener_todo({itemsPerPage: 10, page: 1})          
    },
}
</script>
